<template>
  <template v-if="!editorMode">
    <div :class="classMap" :style="$attrs.style">
      <div class="upload-item" :style="{ width: boxWidth, height: boxHeight }" v-if="!multiple && url !== ''">
        <img :src="poster ? poster : getVideoPosterUrl(url)" class="upload-item__img" @click="showVideoPreview(url)" />
        <div v-if="!disabled && size !== 'mini'" class="video-edit-btn" @click="editVideo()">替换</div>
        <ehf-icon v-if="!disabled" icon="close-circle-fill" class="video-remove-btn" @click="removeVideo()"></ehf-icon>
      </div>
      <template v-if="multiple && urlList.length !== 0">
        <div class="upload-item" :style="{ width: boxWidth, height: boxHeight }" v-for="(img, index) in urlList" :key="index">
          <img :src="getVideoPosterUrl(img)" class="upload-item__img" @click="showVideoPreview(img)" />
          <div v-if="!disabled && size !== 'mini'" class="video-edit-btn" @click="editVideo(index)">替换</div>
          <ehf-icon v-if="!disabled" icon="close-circle-fill" class="video-remove-btn" @click="removeVideo(index)"></ehf-icon>
        </div>
      </template>
      <div
        class="upload-item add"
        :style="{ width: boxWidth, height: boxHeight }"
        v-show="(!multiple && url === '') || (multiple && urlList.length < max)"
        @click="addVideo()"
      >
        <ehf-icon icon="add-fill" class="upload-add-icon"></ehf-icon>
      </div>
    </div>
  </template>
  <a-modal
    v-if="ifModal"
    v-model:open="visibleModal"
    :centered="true"
    destroyOnClose
    width="1000px"
    :confirmLoading="isLoading"
    :maskClosable="canCloseEasily"
    :keyboard="canCloseEasily"
    @cancel="handleCancel()"
    @ok="handleOk()"
  >
    <a-tabs type="card" v-model:activeKey="activeKey" style="height: 530px">
      <a-tab-pane v-for="item of tabArr" :key="item.key" :tab="item.title">
        <component
          :is="item.components"
          :ref="item.key"
          :showUploadOnly="showUploadOnly"
          :limitNumber="maxNum"
          :limitObj="limitObj"
          :limitTime="limitTime"
          v-model:isUploading="loadingFromSelf"
          v-model:videoCount="videoCount"
          :groupId="groupId"
        ></component>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
  <a-modal
    v-model:open="videoPreviewModal.show"
    centered
    title="预览视频"
    :footer="null"
    @cancel="videoPreviewClose"
    :bodyStyle="{ maxHeight: '80vh', display: 'flex', overflow: 'hidden' }"
    :width="'50vw'"
  >
    <video :src="videoPreviewModal.url" ref="previewVideoEl" controls autoplay class="preview-video"></video>
  </a-modal>
</template>

<script>
  import { ref } from 'vue'
  import { uploadVideoAPI } from '@/api/system/videoGroup.js'
  import { getQiniuVideoUrl as getQiniuVideoUrlAPI } from '@/api/project/shoppingMall/courseManage'
  import SelectVideo from './components/SelectVideo'
  import UploadVideo from './components/UploadVideo'
  export default {
    name: 'EhfVideoUpload',
    props: {
      modelValue: {
        type: [String, Array],
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
      // 只展示上传tab页
      showUploadOnly: {
        type: Boolean,
        default: false,
      },
      // 上传url链接到ehf服务器, 有可能比较慢, 给父组件一个控制权
      confirmLoading: {
        type: Boolean,
        default: false,
      },
      // 最多能选几个视频
      max: {
        type: Number,
        default() {
          return 1
        },
      },
      // 单个视频大小
      limit: {
        type: [String, Number],
        default: 2,
      },
      // 单个视频时长
      limitTime: {
        type: [String, Number],
        default: 0,
      },
      // 当上传弹出框弹出来时, 指定是哪个分组, 默认是'0'也就是未分组
      groupId: {
        type: String,
        default() {
          return '0'
        },
      },
      size: {
        type: String,
        default: 'default', // mini, small, default, large
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      scale: {
        type: Object,
        default() {
          return {
            width: 100,
            height: 100,
          }
        },
      },
      editorMode: {
        type: Boolean,
        default: false,
      },
      poster: {
        type: String,
        default: '',
      },
    },
    emits: ['update:visible', 'update:modelValue', 'change'],
    data() {
      return {
        visibleModal: false,
        activeKey: 'select',
        tabArr: [
          { key: 'select', title: '选择视频', components: 'SelectVideo' },
          { key: 'upload', title: '上传视频', components: 'UploadVideo' },
        ],
        loadingFromSelf: false, // 自身的控制权, 包括子控件
        videoCount: 0,
        limitNumber: 0,
        limitSize: 0,
        url: this.modelValue,
        urlList: this.editorMode ? [] : this.modelValue,
        editIndex: -1,
        videoPreviewModal: {
          show: false,
          url: '',
          urlLink: '',
        },
      }
    },
    created() {
      this.limitNumber = this.max
      this.limitSize = this.limit
    },
    setup(props) {
      const ifModal = ref(props.editorMode) // 是否渲染弹窗组件
      // 展示框大小尺寸
      let zoom = 1
      switch (props.size) {
        case 'mini':
          zoom = 0.4
          break
        case 'small':
          zoom = 0.8
          break
        case 'large':
          zoom = 1.2
          break
      }
      let scale_zoom = props.scale.width / props.scale.height
      let boxStyle = {
        width: scale_zoom > 1 ? 100 * scale_zoom * zoom : 100 * zoom,
        height: scale_zoom < 1 ? 100 * (1 / scale_zoom) * zoom : 100 * zoom,
      }
      return {
        boxWidth: boxStyle.width + 'px',
        boxHeight: boxStyle.height + 'px',
        ifModal,
      }
    },
    methods: {
      getVideoPosterUrl(videoUrl) {
        return `${videoUrl}${videoUrl.includes('?') ? '&' : '?'}vframe/jpg/offset/0`
      },
      addVideo() {
        if (this.disabled) {
          return
        }
        this.editIndex = -1
        this.ifModal = true
        this.visibleModal = true
      },
      editVideo(index) {
        if (this.disabled) {
          return
        }
        if (index !== undefined) {
          this.editIndex = index
        } else {
          this.editIndex = -1
        }
        this.ifModal = true
        this.visibleModal = true
      },
      removeVideo(index) {
        if (this.disabled) {
          return
        }
        if (index || index === 0) {
          this.urlList.splice(index, 1)
        } else {
          this.url = ''
        }
        this.onChange()
      },
      handleCancel() {
        this.$refs['upload'] && this.$refs['upload'][0] && this.$refs['upload'][0].stopUploading()
        if (!this.editorMode) {
          setTimeout(() => {
            this.ifModal = false
          }, 460)
        }
        this.visibleModal = false
      },
      async handleOk() {
        if (this.activeKey === 'select') {
          if (this.$refs['select'][0].checkInfo() === false) {
            this.$message.error('请选择视频')
            return
          }
          let tempResult = this.$refs['select'][0].getInfo()
          let urlArr = []
          for (let i_index = 0; i_index < tempResult.length; i_index++) {
            if (tempResult[i_index].includes('videolib')) {
              // 无需请求解密的视频
              urlArr.push(tempResult[i_index])
            } else {
              let throwFlag = false
              await new Promise((resolve) => {
                this.getPlayableUrl(tempResult[i_index])
                  .then((res) => {
                    if (res !== '') {
                      urlArr.push(res)
                      throwFlag = true
                    }
                  })
                  .catch((err) => {
                    console.error('出现异常情况 err: ', err)
                    throwFlag = true
                  })
                  .finally(() => resolve())
              })
              if (!throwFlag) {
                this.$message.error('选择视频失败 请稍后重试')
                return
              }
            }
          }
          this.uploadSuccess(urlArr)
        } else if (this.activeKey === 'upload') {
          // 发送ajax到ehf服务器 如果showUploadOnly为true 则说明是额外需要分组信息, 视频名字信息
          if (this.showUploadOnly === true) {
            if (this.$refs['upload'][0].checkInfo(false) === false) {
              return
            }
            let tempResult = this.$refs['upload'][0].getInfo()
            // 拼接名字或者直接返回
            let getVideoName = (function () {
              let increment = 0
              return function () {
                increment++
                // 等于空, 意味着用文件原本的名字
                if (tempResult.videoName === '') {
                  return tempResult.fileArr[increment - 1].name
                }
                // 不等于空, 意味着用用户定义的名字加序列号
                else {
                  if (tempResult.urlArr.length > 1) {
                    return tempResult.videoName + '-' + increment
                  }
                }
                return tempResult.videoName
              }
            })()
            let urlArr = tempResult.urlArr.map((item, index) => {
              return {
                urlLink: item.videoLink,
                urlTemp: item.videoSrc,
                duration: tempResult.durationArr[index],
                name: getVideoName(),
                groupID: tempResult.selectedGroupId,
                size: tempResult.fileArr[index].size,
              }
            })
            this.uploadSuccess(urlArr)
          } else {
            // 这种情况认为是富文本编辑器, 只需要url, 目前需要上传到易哈佛服务器上
            if (this.$refs['upload'][0].checkInfoForEditor() === false) {
              return
            }
            let tempResult = this.$refs['upload'][0].getInfo()
            let urlArr = []
            let dataArr = tempResult.urlArr.map((item, index) => {
              urlArr.push(item.videoSrc)
              return {
                url: item.videoLink,
                name: item.fileName,
                group_id: tempResult.selectedGroupId,
                time: tempResult.durationArr[index],
                size: tempResult.fileArr[index].size,
              }
            })
            let isUploadSuccess = false
            await new Promise((resolve, reject) => {
              this.uploadVideo(dataArr)
                .then((res) => {
                  isUploadSuccess = res
                  resolve()
                })
                .catch((err) => {
                  this.$message.error(err)
                  console.error('上传视频到易哈佛报错 err', err)
                  reject()
                })
            })
            if (isUploadSuccess) {
              this.uploadSuccess(urlArr)
            }
          }
        }
      },
      uploadSuccess(urls) {
        if (urls.length === 0) {
          return this.$message.error('未上传或选择视频')
        }
        if (this.multiple || this.editorMode) {
          if (this.editIndex !== -1) {
            this.urlList.splice(this.editIndex, 1, urls[0])
          } else {
            this.urlList = this.urlList.concat(urls)
          }
        } else {
          this.url = urls[0]
        }
        this.onChange()
        this.visibleModal = false
      },
      onChange() {
        if (this.multiple || this.editorMode) {
          this.$emit('update:modelValue', this.urlList)
          this.$emit('change', this.urlList)
        } else {
          this.$emit('update:modelValue', this.url)
          this.$emit('change', this.url)
        }
      },
      // 上传视频到易哈佛服务器
      async uploadVideo(dataArr) {
        let returnFlag = true
        this.loadingFromSelf = true
        let promiseList = dataArr.map((body) => {
          return uploadVideoAPI(body)
        })
        await Promise.all(promiseList)
          .then((resList) => {
            resList.forEach((res) => {
              if (parseInt(res.code) !== 0) {
                this.$message.error(res.msg)
                console.error('报错 上传视频url到易哈佛服务器 code ', res.code)
                returnFlag = false
              }
            })
          })
          .catch((err) => {
            console.error('报错 异步请求失败 上传视频url到易哈佛服务器 err', err)
            returnFlag = false
          })
          .finally(() => {
            this.loadingFromSelf = false
          })
        return returnFlag
      },
      // 获取可播放的链接
      async getPlayableUrl(link) {
        let tempUrl = ''
        await getQiniuVideoUrlAPI({ link: link })
          .then((res) => {
            if (parseInt(res.code) === 0) {
              tempUrl = res.data
            } else {
              this.$message.error(res.code, res.msg)
              console.error('请求七牛临时视频播放地址失败: ', res)
            }
          })
          .catch((err) => {
            this.$message.error(err.code, err.msg)
            console.error('请求七牛临时视频播放地址失败: ', err)
          })
        return tempUrl
      },
      async showVideoPreview(url) {
        if (this.videoPreviewModal.urlLink === url) {
          // 相同视频链接继续播放
          this.videoPreviewModal.show = true
          if (this.$refs['previewVideoEl']) {
            this.$refs['previewVideoEl'].play()
          }
          return
        }
        let urlSrc = ''
        if (url.includes('videolib')) {
          // 无需请求解密的视频
          urlSrc = url
        } else {
          await new Promise((resolve, reject) => {
            getQiniuVideoUrlAPI({ link: url })
              .then((res) => {
                if (parseInt(res.code) === 0) {
                  urlSrc = res.data
                } else {
                  this.$message.error(res.code, res.msg)
                  console.error('请求七牛临时视频播放地址失败: ', res)
                }
                resolve()
              })
              .catch((err) => {
                this.$message.error(err.code, err.msg)
                console.error('请求七牛临时视频播放地址失败: ', err)
                reject()
              })
          })
        }
        this.videoPreviewModal = {
          show: true,
          url: urlSrc,
          urlLink: url,
        }
      },
      videoPreviewClose() {
        this.$refs['previewVideoEl'].pause()
      },
    },
    mounted() {
      if (this.showUploadOnly === true && this.tabArr.length === 2) {
        this.tabArr.shift()
      }
    },
    components: {
      SelectVideo,
      UploadVideo,
    },
    computed: {
      // 如果父类要求, 或者自身(也就是本文档)认为正在上传, 都为true
      isLoading() {
        return this.confirmLoading || this.loadingFromSelf
      },
      canCloseEasily() {
        return !(this.videoCount > 0 || this.isLoading)
      },
      classMap() {
        return ['upload-wrapper', this.size, { disabled: this.disabled }, { multiple: this.multiple }]
      },
      multiple() {
        return Array.isArray(this.modelValue)
      },
      maxNum() {
        if (this.multiple) {
          if (this.editIndex !== -1) {
            return 1
          } else {
            return this.limitNumber - this.urlList.length
          }
        } else {
          return 1
        }
      },
      limitObj() {
        const limit_str = this.limit.toString().toLocaleLowerCase()
        const reg = /^\d*(kb|mb|gb)?$/
        if (this.limit === '' || !reg.test(limit_str)) {
          return {
            text: '2GB',
            size: 2 * 1024 * 1024 * 1024,
          }
        } else {
          let limit_num = parseFloat(limit_str)
          if (/^\d*$/.test(limit_str) || limit_str.indexOf('gb') > -1) {
            // 纯数字或gb，默认单位gb，最大2
            if (limit_num > 2) {
              return {
                text: '2GB',
                size: 2 * 1024 * 1024 * 1024,
              }
            } else {
              return {
                text: limit_num + 'GB',
                size: limit_num * 1024 * 1024 * 1024,
              }
            }
          } else if (limit_str.indexOf('kb') > -1) {
            return {
              text: limit_num + 'KB',
              size: limit_num * 1024,
            }
          } else {
            return {
              text: limit_num + 'MB',
              size: limit_num * 1024 * 1024,
            }
          }
        }
      },
    },
    watch: {
      visibleModal: {
        handler: function (newValue) {
          if (this.editorMode) {
            this.$emit('update:visible', newValue)
          }
        },
      },
      modelValue: {
        handler: function (newValue) {
          if (this.multiple) {
            this.urlList = newValue
          } else {
            this.url = newValue
          }
        },
      },
      visible: {
        handler: function (newValue) {
          if (newValue) {
            this.urlList = []
          }
          this.visibleModal = newValue
        },
      },
      showUploadOnly: {
        immediate: true,
        handler: function (newValue) {
          if (newValue) {
            this.activeKey = 'upload'
          }
        },
      },
    },
  }
</script>

<style lang="scss" scoped>
  .upload-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 -5px;
    .upload-item {
      /*width: 100px;*/
      /*height: 100px;*/
      margin: 0 5px;
      border: 1px none #cccccc;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .upload-item__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .video-edit-btn {
        display: none;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
      .video-remove-btn {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        transform: translate(50%, -50%);
        font-size: 20px;
        line-height: initial;
        &:after {
          content: '';
          position: absolute;
          width: 15px;
          height: 15px;
          left: 3px;
          top: 3px;
          background-color: #fff;
          border-radius: 50%;
          z-index: -1;
        }
      }
      .set-main-btn {
        position: absolute;
        top: 0;
        left: 0;
        background-color: $ehf-color-blue;
        color: #ffffff;
        font-size: 12px;
        line-height: initial;
        padding: 5px;
        cursor: pointer;
        display: none;
      }
      &:hover {
        .video-edit-btn {
          display: block;
        }
        .video-remove-btn {
          display: block;
        }
        .set-main-btn {
          display: block;
        }
      }
    }
    .upload-item.add {
      cursor: pointer;
      border-style: dashed;
    }
    .upload-item.draggable {
      cursor: move;
    }
  }
  .upload-wrapper.multiple {
    .upload-item {
      margin-bottom: 10px;
    }
  }
  .upload-wrapper.disabled {
    .upload-item {
      &:hover {
        .video-edit-btn {
          display: none;
        }
        .video-remove-btn {
          display: none;
        }
      }
    }
    .upload-item.add {
      background-color: #eeeeee;
      cursor: not-allowed;
    }
  }
  .modal-close-btn {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  .ant-tabs-card {
    height: 100%;
  }

  .preview-video {
    width: 100%;
    background-color: #000;
    position: relative;
  }
</style>
